import { ReactNode, useState } from 'react';
import { Box } from '@mui/material';
import ProfileTabBar from './ProfileTabBar';
import TimelineTab from './TimelineTab';
import AppointmentsTab from './AppointmentsTab';
import PaymentsTab from './PaymentsTab';
import FormsAndFilesTab from './FormsAndFilesTab';
import { PROFILE_TAB, TAB_DEFINITIONS } from '../../../../constants/customers';
import { TabId } from '../../../../types/customers';

interface Props {
  customerId: string;
  businessId: string;
  onUploadFile: () => void;
  profile?: ReactNode;
}

function CustomerProfileTabs({
  customerId,
  businessId,
  onUploadFile,
  profile,
}: Props) {
  const [activeTab, setActiveTab] = useState<TabId>(
    profile ? 'profile' : 'timeline',
  );
  const tabs = profile ? [PROFILE_TAB, ...TAB_DEFINITIONS] : TAB_DEFINITIONS;

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'profile':
        return profile;
      case 'timeline':
        return <TimelineTab customerId={customerId} businessId={businessId} />;
      case 'appointments':
        return (
          <AppointmentsTab customerId={customerId} businessId={businessId} />
        );
      case 'payments':
        return <PaymentsTab customerId={customerId} businessId={businessId} />;
      case 'forms-files':
        return (
          <FormsAndFilesTab
            customerId={customerId}
            businessId={businessId}
            onUploadFile={onUploadFile}
          />
        );
      default: {
        const exhaustiveCheck: never = activeTab;
        throw new Error(`Unhandled tab: ${JSON.stringify(exhaustiveCheck)}`);
      }
    }
  };

  return (
    <Box>
      <ProfileTabBar
        tabs={tabs}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {renderActiveTab()}
    </Box>
  );
}

export default CustomerProfileTabs;
